import * as React from "react";
import {useTranslation} from "react-i18next";
import "./AdvantagesBanner.scss";

/**
 * @component
 */
export function AdvantagesBanner() {
  const {t} = useTranslation(["cart"]);

  return (
    <div className="AdvantagesBanner">
      <div className="Wrapper">
        <ul className="GreenCheckmark">
          <li>{t("30 Tage Rückgaberecht")}</li>
          <li>{t("Kostenlose Retouren bei Paketware")}</li>
          <li>{t("Klimaneutraler Versand")}</li>
          <li>
            <span>&#160;</span>
          </li>
        </ul>
      </div>
      <span className="Gradient">&#160;</span>
    </div>
  );
}
